/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'pool-group-deployment-policy';

export const poolGroupDeploymentPolicyModalBreadcrumbTitle =
    `${prefix}.poolGroupDeploymentPolicyModalBreadcrumbTitle`;

export const ENGLISH = {
    [poolGroupDeploymentPolicyModalBreadcrumbTitle]: 'Pool Group Deployment Policy',
};
